import { DialogActions, DialogContent, Grid, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { MprcRequestIndicator } from "components";
import { ButtonCancel, ButtonSave } from "components/buttons";
import { MprcContainer } from "components/MprcContainer";
import { MprcRequestErrorDialog } from "components/MprcRequestErrorDialog";
import { MprcText } from "components/MprcText";
import { ManagedRoleUserConflitResolutionResponse } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    roleId: string;
    userId: string;
    viewData: ManagedRoleUserConflitResolutionResponse;
    recordChanged: boolean;
    onReload: () => void;
    onFormUpdate: (dto: ManagedRoleUserConflitResolutionResponse) => void;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Edição das Permissões de um Papel Segurança
 * @param props
 */
export const EditRoleUserConflits: React.FC<IProps> = (props) => {
    ////////////////////////////////////////////////////////////////////////////
    const { roleId, userId, viewData, recordChanged, onReload, onFormUpdate } = props;
    const [saving, setSaving] = useState<boolean>(false);
    const [viewError, setViewError] = useState<any>();

    const api = useCoreApi();
    const { t } = useTranslation();

    ////////////////////////////////////////////////////////////////////////////

    ///
    const handleSave = () => {
        setSaving(true);
    };

    const handleCancel = () => {
        onReload();
    };

    const handleChange = (event: SelectChangeEvent<number>) => {
        if (event.target.value) onFormUpdate({ ...viewData, currentOption: event.target.value as number });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// Effect's
    ////////////////////////////////////////////////////////////////////////////

    // Ao salvar um DTO:
    useEffect(() => {
        async function postData() {
            try {
                await api.v1.securityRoleManagement.saveUserConflitResolution({
                    roleId,
                    userId,
                    mergeOption: viewData.currentOption
                });

                onReload();
            }
            catch (e) {
                setViewError(e);
            }

            setSaving(false);
        }

        if (saving) postData();
    }, [saving]);

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    const RenderForm = () => {
        return (
            <MprcContainer>

                <MprcRequestIndicator
                    visible={saving}
                    type={"post"}
                />

                <MprcContainer>
                    <MprcText color="muted">
                        {t("Role.Edit.User.Conflits.WhatConstraintsMessage")}
                    </MprcText>
                </MprcContainer>

                <Select
                    value={viewData.currentOption}
                    onChange={handleChange}
                >
                    {
                        Object.entries(viewData.options ?? {})
                            .map((item, index) => <MenuItem key={index} value={item[0]}>{item[1]}</MenuItem>)
                    }
                </Select>

            </MprcContainer>
        );
    };

    return (
        <>
            <DialogContent sx={{ pt: 0, height: "100vh" }}>
                {
                    viewError
                        ? <MprcRequestErrorDialog error={viewError} onClose={() => setViewError(null)} />
                        : <RenderForm />
                }
            </DialogContent>

            <DialogActions>
                <Grid container spacing={1} justifyContent="flex-end" width="100%">
                    {
                        recordChanged &&
                        <Grid>
                            <ButtonCancel
                                variant="contained"
                                onClick={handleCancel}
                            />
                        </Grid>
                    }
                    <Grid>
                        <ButtonSave
                            disabled={!recordChanged}
                            onClick={handleSave}
                        />
                    </Grid>
                </Grid>
            </DialogActions>
        </>
    );
};
